import styled, { keyframes } from 'styled-components';

import { Theme } from '@/shared/themes';

const loading = keyframes`
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const Button = styled.button`
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;
  color: ${({ theme }: { theme: Theme }) => theme.colors.button.red.text};
  background-color: ${({ theme }: { theme: Theme }) => theme.colors.button.red.background};
  -webkit-tap-highlight-color: transparent;
  border-radius: 28px;
  font-size: 21px;
  line-height: 140%;
  cursor: pointer;

  &:hover,
  &:active,
  &:focus {
    background-color: ${({ theme }: { theme: Theme }) => theme.colors.button.red.backgroundHover};
  }

  &:disabled {
    pointer-events: none;
    opacity: 0.5;
  }

  svg {
    animation-name: ${loading};
    animation-duration: 2s;
    animation-iteration-count: infinite;
  }
`;
